import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ScrollFabButton } from 'components/components/ScrollFabButton';
import BrandLinksContainer from './containers/BrandsLinksContainer/BrandLinksContainer';
import LetterPickerContainer from './containers/LetterPickerContainer/LetterPickerContainer';
import { useBrandsData } from './hooks/useBrandsData';

const BrandsPage: React.FC = () => {
  useBrandsData();

  const handleBackUpArrowClick = () => {
    window.scrollTo(0, 0);
  };

  const matches = useMediaQuery('(max-width:767px)');

  return (
    <>
      <ScrollFabButton
        onClick={handleBackUpArrowClick}
        bottom={matches ? 125 : 89}
        right={32}
      />
      <LetterPickerContainer />
      <BrandLinksContainer />
      {/* bottom line for Sticky */}
      <div id="bottomLine"></div>
    </>
  );
};

export default BrandsPage;
